import { Fragment, FC } from "react";

const Location: FC<{ color: string }> = ({ color = "white" }) => {
  return (
    <Fragment>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.0026 15.6666C16.6451 15.6666 17.1941 15.4379 17.6497 14.9803C18.1052 14.5228 18.333 13.9728 18.333 13.3303C18.333 12.6879 18.1042 12.1388 17.6467 11.6833C17.1892 11.2277 16.6392 11 15.9967 11C15.3542 11 14.8052 11.2287 14.3497 11.6863C13.8941 12.1438 13.6663 12.6938 13.6663 13.3363C13.6663 13.9787 13.8951 14.5277 14.3526 14.9833C14.8102 15.4388 15.3602 15.6666 16.0026 15.6666ZM15.9997 26.7C18.9552 24.0111 21.1386 21.5722 22.5497 19.3833C23.9608 17.1944 24.6663 15.2666 24.6663 13.6C24.6663 10.9824 23.8298 8.83913 22.1566 7.17013C20.4835 5.50113 18.4312 4.66663 15.9997 4.66663C13.5682 4.66663 11.5159 5.50113 9.84274 7.17013C8.16959 8.83913 7.33301 10.9824 7.33301 13.6C7.33301 15.2666 8.05523 17.1944 9.49967 19.3833C10.9441 21.5722 13.1108 24.0111 15.9997 26.7ZM15.9997 29.3333C12.4219 26.2888 9.74967 23.4611 7.98301 20.85C6.21634 18.2388 5.33301 15.8222 5.33301 13.6C5.33301 10.2666 6.40523 7.61107 8.54967 5.63329C10.6941 3.65551 13.1775 2.66663 15.9997 2.66663C18.8219 2.66663 21.3052 3.65551 23.4497 5.63329C25.5941 7.61107 26.6663 10.2666 26.6663 13.6C26.6663 15.8222 25.783 18.2388 24.0163 20.85C22.2497 23.4611 19.5775 26.2888 15.9997 29.3333Z"
          fill={color}
        />
      </svg>
    </Fragment>
  );
};

export default Location;
